'use client'
import AppRouterNav from './app-router'
import PagesRouterNav from './pages-router'
import { trackNavClickEvent, type NavDataProps } from './component'

export { AppRouterNav, trackNavClickEvent, NavDataProps }
export default PagesRouterNav
